import { GetFieldForFilterAndSort } from '../Util/Field';

const DocumentSubscriptionCollectionFields = [
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[Name].keyword",
		"Document Name",
		"FieldType_Text",
		"Meta_text_kw256lc[Name]",
	),
	GetFieldForFilterAndSort(
		"Meta_date_str256[CreatedOn].string",
		"Created On",
		"FieldType_Date",
	),
	GetFieldForFilterAndSort(
		"Meta_date_str256[ItemCreatedOn].string",
		"Document Created On",
		"FieldType_Date",
	),
	GetFieldForFilterAndSort(
		"Meta_long[FileSize]",
		"File Size",
		"FieldType_Number",
	),
	GetFieldForFilterAndSort(
		"Meta_int[PageCount]",
		"Page Count",
		"FieldType_Number",
	),
];

export default DocumentSubscriptionCollectionFields;